var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-visual-border",class:{
    f: _vm.$props.isFirst,
    l: _vm.$props.isLast,
    b: _vm.$props.showBorder,
    r: _vm.$props.replaceStyle,
  },style:({
    borderLeftWidth: _vm.horizontalBorderWidth,
    borderRightWidth: _vm.horizontalBorderWidth,
  })})}
var staticRenderFns = []

export { render, staticRenderFns }